import { axiosInstance } from '../api';

export default function(questionnaireResponse) {
    return axiosInstance.post(`/fhir/QuestionnaireResponse`, questionnaireResponse);
}